/* eslint-disable prefer-arrow-callback */
/* eslint-disable prefer-promise-reject-errors */
// eslint-disable-next-line func-names
const connector = () => new Promise(function (resolve, reject) {
    const request = indexedDB.open('offlineDB', 1);
    request.onupgradeneeded = (e) => {
        const db = e.target.result; // also available on request.result

        const animalsStore = db.createObjectStore('animals', { keyPath: 'id' });
        // stores are like tables in indexedDB
        animalsStore.createIndex('EarTagNoIndex', 'earTagNo', { unique: true });
        // make earTagId as index to able to retrieve data using earTagID
        db.createObjectStore('syncEditAnimals', { keyPath: 'offlineId' });
        db.createObjectStore('syncAnimals', { keyPath: 'offlineId' });
        const breedsStore = db.createObjectStore('breeds', { keyPath: 'id' });
        breedsStore.createIndex('BreedNameIndex', 'breedName', { unique: true });
        // make breedName as index to able to retrieve data using breedName
        const farmsStore = db.createObjectStore('farms', { keyPath: 'id' });
        farmsStore.createIndex('NameIndex', 'name', { unique: false });
        // make name as index to able to retrieve data using farm name (check for name existence on add farm)
        const groupsStore = db.createObjectStore('groups', { keyPath: 'id' });
        groupsStore.createIndex('FarmIdIndex', 'farmId', { unique: false });
        // make farmId as index to able to retrieve data using related farm
        db.createObjectStore('files', { keyPath: 'id' });
        const eventStore = db.createObjectStore('events', { keyPath: 'id' });
        eventStore.createIndex('AnimalIdIndex', 'animalId', { unique: false });
        // make eventId as index to able to retrieve data using related event
        const eventMessagesStore = db.createObjectStore('eventMessages', { keyPath: 'id' });
        eventMessagesStore.createIndex('EventIdIndex', 'eventId', { unique: false });
        // make eventId as index to able to retrieve data using related event
        db.createObjectStore('syncEvents', { keyPath: 'offlineId' });
        const syncEventMessagesStore = db.createObjectStore('syncEventMessages', { keyPath: 'offlineId' });
        syncEventMessagesStore.createIndex('EventIdIndex', 'eventId', { unique: false });
        // make eventId as index to able to retrieve data using related event
        // monthlyMethane store
        const monthlyMethaneStore = db.createObjectStore('monthlyMethane', { autoIncrement: true });
        monthlyMethaneStore.createIndex('FarmIdIndex', 'farmId', { unique: false });
        monthlyMethaneStore.createIndex('AnimalIdIndex', 'animalId', { unique: false });
        // weeklyMethane store
        const weeklyMethaneStore = db.createObjectStore('weeklyMethane', { autoIncrement: true });
        weeklyMethaneStore.createIndex('FarmIdIndex', 'farmId', { unique: false });
        weeklyMethaneStore.createIndex('AnimalIdIndex', 'animalId', { unique: false });
        db.createObjectStore('appData', { keyPath: 'name' });
        const userPermisionssStore = db.createObjectStore('userPermissions', { keyPath: 'farmId' });
        userPermisionssStore.createIndex('FarmIdIndex', 'farmId', { unique: true });
        // make farmId as index to able to retrieve data using farmId
    }
    request.onerror = (e) => {
        reject(e.target.errorCode);
    }
    request.onsuccess = async (e) => {
        const db = e.target.result; // also available on request.result
        if (db) {
            resolve(db);
        }
        else {
            reject('Error on opening database!')
        }
    }
});

export default connector;
